import { Component, Input, OnInit } from '@angular/core';

import { IColunaMascara } from '../../interface/icm-mascara-generico';

@Component({
    selector: 'icm-coluna-mascara',
    templateUrl: './view/icm-coluna-mascara.component.html',
    styleUrls: ['./view/icm-coluna-mascara.component.scss'],
})
export class IcmColunaMascaraComponent implements OnInit {
    @Input() linha: any;
    @Input() coluna: IColunaMascara;
    @Input() carregando: boolean;

    texto: string;
    mascara: string;
    corTexto: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.texto = this.coluna.valor(this.linha);
        this.mascara = this.coluna.mascara(this.linha);

        if (this.coluna?.cor) this.corTexto = this.coluna.cor(this.linha);
    }
}
